export default __webpack_public_path__ + "static/char-08-anr-20846528d65e95a2e229db525e7a67d9.gif";